module.exports = __webpack_public_path__ + "img/resize-element.a5b6ea03.svg";